import React from 'react'

import {WineInfoCH} from '../../components/modules/accordion/WineInfo';
import {WineTerroirCH} from '../../components/modules/accordion/WineTerroir';
import {WineCellerCH} from '../../components/modules/accordion/WineCeller';
import {WineEttColtCH} from '../../components/modules/accordion/WineEttColt';
import {WineBottlesCH} from '../../components/modules/accordion/WineBottles';

function Chieti({data}) {

  return (
    <>
      {data[0] && <WineInfoCH />}
      {data[1] && <WineTerroirCH />}
      {data[2] && <WineCellerCH />}
      {data[3] && <WineEttColtCH />}
      {data[4] && <WineBottlesCH />}
    </>
  )
}

export default Chieti;
